import { Accordion } from '../Accordion/Accordion';
import { SetupInstructionsProps } from './types';
import classes from './SSOSettings.module.css';

export const SetupInstructions = ({ t }: SetupInstructionsProps) => (
  <div className={classes.instructionsSection}>
    <Accordion title={t('ssoSettings.setupInstructions.title')}>
      <ol className={classes.instructions}>
        <li>{t('ssoSettings.setupInstructions.steps.step1')}</li>
        <li>{t('ssoSettings.setupInstructions.steps.step2')}</li>
        <li>{t('ssoSettings.setupInstructions.steps.step3')}</li>
        <li>{t('ssoSettings.setupInstructions.steps.step4')}</li>
        <li>{t('ssoSettings.setupInstructions.steps.step5')}</li>
        <li>{t('ssoSettings.setupInstructions.steps.step6')}</li>
      </ol>
    </Accordion>
  </div>
);
